import { Button } from '@progress/kendo-react-buttons';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface Props {
  onClick: () => void;
}

export default function PremiumFeatureSnackbar({ onClick }: Props) {
  const { t } = useTranslation();

  return (
    <div className="snackbar-container premium-feature-snackbar">
      <span style={{ fontSize: '14px' }}>
        {t('subscriptions.notifications.feature_available_in_premium')}
      </span>

      <Button themeColor="primary" onClick={onClick}>
        {t('upgrade')}
      </Button>
    </div>
  );
}
